<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">报警记录</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="动环设备">
            <el-select v-model="FsuCode" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in EquipArr"
                :key="item.DeviceId"
                :label="item.DeviceName"
                :value="item.DeviceId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报警等级">
            <el-select v-model="alarmLevel" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in alarmLevelArr"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报警状态">
            <el-select v-model="alarmStatus" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in alarmStatusArr"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报警时间" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 60rem"
              unlink-panels
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="FsuCode"
                label="设备名称"
                :formatter="getDeviceShow"
              >
              </el-table-column>
              <el-table-column
                prop="ChannelName"
                label="通道名称"
              ></el-table-column>
              <el-table-column
                prop="SignalName"
                label="报警名称"
              ></el-table-column>
              <el-table-column prop="AlarmLevel" label="报警等级">
                <template slot-scope="scope">
                  <span
                    :style="{ color: scope.row.AlarmLevelColor }"
                    v-if="scope.row.AlarmLevel == 1"
                    >一级告警</span
                  >
                  <span
                    :style="{ color: scope.row.AlarmLevelColor }"
                    v-else-if="scope.row.AlarmLevel == 2"
                    >二级告警</span
                  >
                  <span
                    :style="{ color: scope.row.AlarmLevelColor }"
                    v-else-if="scope.row.AlarmLevel == 3"
                    >三级告警</span
                  >
                  <span
                    :style="{ color: scope.row.AlarmLevelColor }"
                    v-else-if="scope.row.AlarmLevel == 4"
                    >四级告警</span
                  >
                </template>
              </el-table-column>

              <el-table-column prop="AlarmStatus" label="报警状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.AlarmStatus == 0">报警产生</span>
                  <span v-else-if="scope.row.AlarmStatus == 1">报警结束</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="BeginTime"
                label="开始时间"
                :formatter="formatDate"
              ></el-table-column>
              <el-table-column
                prop="EndTime"
                label="结束时间"
                :formatter="formatDate"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import EqApis from "../../../../../equipment/src/apis";
export default {
  name: "dynEnvironmentAlarmView",
  controller: "UI",
  action: "dynEnvironmentAlarmView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      deviceName: "",
      FsuCode: null,
      EquipArr: [],
      loading: false,
      loadingText: "加载中...",
      alarmLevel: null,
      alarmLevelArr: [
        { value: 1, name: "一级告警" },
        { value: 2, name: "二级告警" },
        { value: 3, name: "三级告警" },
        { value: 4, name: "四级告警" },
      ],
      alarmStatus: null,
      alarmStatusArr: [
        { value: 0, name: "未结束" },
        { value: 1, name: "已结束" },
      ],
      date: [new Date(new Date() - 7 * 24 * 60 * 60 * 1000), new Date()],
      BeginTime: null,
      EndTime: null,
    };
  },
  created: function () {
    //获取动环设备
    this.getEquipInfo();
  },
  mounted: function () {
    this.search();
    this.logInfo.ActionName = "动环报警记录查看";
    this.logInfo.LogMessage = "动环报警记录查看";
    this.logInfo.ModuleName = "动环管理";
    this.logInfo.PageName = "动环报警记录列表页";
    this.addOperationLog();
  },
  methods: {
    getEquipInfo() {
      let searchInfo = {
        EquipmentType: "DynamicEnvironment", //设备类型

        DeviceType: "SubSystem.DynamicEnvironment",
        DeviceTypes: [],

        PageSize: 100,
        PageIndex: 1,
      };
      new EqApis.MonitorApi()
        .GetEquipmentPagingList(searchInfo)
        .then((r) => {
          //console.log("1");
          r = r.data.Data;
          this.EquipArr = r.PageContents;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    search() {
      let data = this.date;
      if (data.length > 0) {
        this.BeginTime =
          this.date == null || this.date == ""
            ? null
            : this.date[0].format("yyyy-MM-ddT00:00:00");
        this.EndTime =
          this.date == null || this.date == ""
            ? null
            : this.date[1].format("yyyy-MM-ddT23:59:59");
      }
      let searchInfo = {
        FsuCode: this.FsuCode === "" ? null : this.FsuCode,
        AlarmLevel: this.alarmLevel === "" ? null : this.alarmLevel,
        AlarmStatus: this.alarmStatus === "" ? null : this.alarmStatus,
        BeginDate: this.BeginTime,
        EndDate: this.EndTime,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      this.loading = true;
      new MyApis.TranResourcesApi()
        .GetPageContentByConditions(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/dynEnvironment/UI/dynEnvironmentAlarmInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/dynEnvironment/ui/dynEnvironmentAlarmInfo",
        query: { InfoId: row.Id, type: "query" },
      });
    },

    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.date = [new Date(new Date() - 7 * 24 * 60 * 60 * 1000), new Date()];
      this.FsuCode = null;
      this.alarmLevel = null;
      this.alarmStatus = null;
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
    getDeviceShow(row, column) {
      let that = this;
      let data = row[column.property];
      if (data) {
        let arr = that.EquipArr;
        let result = "";
        arr.forEach((item) => {
          if (item.DeviceId == data) {
            result = item.DeviceName;
          }
        });
        return result;
      }
    },
  },
};
</script>
